<template>
    <div class="game-card p-2">
        <div class="game-image position-relative">
            <div @click="$emit('click', game)">
                <SkeletonImage
                    :src="game.image_url"
                    :alt="game.gameName"
                    class="h-100 w-100"
                />
                <!-- <img
                    :src="game.image_url"
                    :alt="game.gameName"
                    class="h-100 w-100"
                > -->
            </div>
        </div>

        <!-- Game Info -->
        <div
            style="cursor: pointer;"
            @click="$emit('click', game)"
        >
            <p
                class="mb-0 text-uppercase text-center text-ellipsis"
                style="font-size: .7rem; color: #ccc;"
            >
                {{ game.gameName }}
            </p>
            <!-- <p
                class="text-center text-uppercase text-muted text-ellipsis font-weight-bold mb-0"
                style="line-height: 1; color: #fff;"
            >
                <small>{{ game.provider }}</small>
            </p> -->
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import SkeletonImage from './SkeletonImage.vue';

export default {
    components: {
        SkeletonImage
    },
    props: {
        game: {
            type: Object,
            required: true
        },
    },
    methods: {
    }
};
</script>

<style scoped>
.save-btn {
    cursor: pointer;
    font-size: 1.1rem;
    position: absolute;
    top: -8px;
    right: -7px;
    background: rgba(0, 0, 0, .6);
    padding: 1rem;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-btn {
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);

    background: #d4c23f;
    color: black;
    border-radius: 20px;
    border: 0;
    padding: 4px 1.5rem;
    font-size: 0.7rem;
    text-align: center;
    box-shadow: none;
}

.player-count {
    font-size: 0.7rem;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, .6);
    color: #fff;
    padding: 2px 4px;
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    justify-content: center;

    i {
        color: rgb(17, 255, 17);
        transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
        animation: blinker .8s linear infinite;
    }
}

@keyframes blinker {
    50% {
        opacity: .4;
    }
}
</style>
